import {createAction} from "redux-actions";
import {SET_ANNOUNCEMENTS} from "./announcements_table_type";

export const setAnnouncements = createAction(SET_ANNOUNCEMENTS);
